import global from "../../../config/global";

export const getRolesURL = global.apisUrl + "/roles";

export const companyURL = (id) =>
  global.apisUrl + `/companies${id ? "/" + id : ""}`;

export const childCompaniesURL = companyURL() + "/child-companies";

export const multiCompanyURL = companyURL() + "/multi";

export const myCompanyURL = companyURL() + "/my-company";

export const currencyURL = (module, currency) =>
  global.apisUrl +
  `/currencies${currency && module ? `/${module}/${currency}` : ""}`;

export const userURL = (id) => global.apisUrl + `/users${id ? "/" + id : ""}`;

export const userDelURL = (id) => global.apisUrl + `/users/${id}`;

export const modulesURL = global.apisUrl + `/users/all-modules`;

export const userModulesURL = (id) => global.apisUrl + `/users/modules/${id}`;
